import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { categoryBySlug, imgSrc } from "../lib/api";

export default function ArticleCard({ article, size = "md" }) {
  const cat = categoryBySlug(article.category);
  const aspect =
    size === "lg" ? "aspect-[4/5]" : size === "sm" ? "aspect-[5/4]" : "aspect-[4/5]";

  return (
    <Link
      to={`/article/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="brutal-card overflow-hidden flex flex-col group block"
    >
      <div className={`relative ${aspect} overflow-hidden border-b-2 border-black`}>
        <img
          src={imgSrc(article.cover_image)}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <span
          className="pill-tag absolute top-3 left-3"
          style={{ background: cat?.color || "#FFD01E", color: cat?.textColor || "#050505" }}
        >
          {cat?.label || article.category}
        </span>
        {article.sub_category && (
          <span className="pill-tag absolute top-3 right-3 bg-[#FFFDF7]">
            {article.sub_category.replace(/-/g, " ")}
          </span>
        )}
      </div>
      <div className="p-5 flex-1 flex flex-col gap-3">
        <h3 className="font-display text-2xl leading-tight">
          {article.title}
        </h3>
        <p className="text-sm text-black/70 line-clamp-2">{article.excerpt}</p>
        <div className="mt-auto flex items-center justify-between pt-3 text-xs uppercase font-bold tracking-wide">
          <span>par {article.author}</span>
          <span className="flex items-center gap-1">
            {article.read_time} min <ArrowUpRight size={14} strokeWidth={2.5} />
          </span>
        </div>
      </div>
    </Link>
  );
}
